export const QUERY_LIBRARY_TAB = 'libraryTab'

export enum LibraryTabs {
  FAVORITES = 'favorites',
  PURCHASED = 'purchased',
}

export type LibraryTabNames = {
  favorites: string
  purchased: string
}
